import React, { ChangeEvent, ForwardedRef, InputHTMLAttributes } from "react";

export function InputTextBox(props: InputTextBoxParams) {
    const { handleTextChanged, label, isPassword, hasError, ...rest } = props;

    const inputType = isPassword? "password" : "text";

    const errorClassName = hasError? "error" : "";

    const renderLabel = (label: string | undefined) => {
        if (!label) return null;
        return (
            <div className={"text_box__label"}>
                {label}
            </div>
        );
    };
    return (
        <div className={`input text_box ${errorClassName}`}>
            {renderLabel(label)}
            <input 
                className={`text_box__input ${errorClassName}`} 
                type={inputType} 
                onChange={(e: ChangeEvent<HTMLInputElement>) => { handleTextChanged(e.target.value); }} 
                {...rest}
            />
        </div>
    );
}

export interface InputTextBoxParams extends InputHTMLAttributes<HTMLInputElement> {
    handleTextChanged: (value: string) => void,
    label?: string,
    isPassword?: boolean,
    hasError?: boolean,
    ref?: ForwardedRef<HTMLInputElement>,
}
